var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47034 6.50855C7.92054 6.9824 7.91976 7.72613 7.46858 8.19903L1.91456 14.0205C1.55662 14.3956 0.957797 14.3956 0.599861 14.0205C0.264338 13.6688 0.265038 13.1153 0.601449 12.7645L4.97753 8.20089C5.43142 7.72755 5.43236 6.98081 4.97967 6.50632L0.627648 1.94476C0.292701 1.59369 0.292701 1.04139 0.627649 0.690312C0.986142 0.314558 1.58609 0.315184 1.9438 0.691685L7.47034 6.50855Z",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.108af78ea7acc64001c54513d22aa86f.svg";
export { ForwardRef as ReactComponent };